export default "__VITE_ASSET__JrxQ2JfB__"